module.exports = __webpack_public_path__ + "static/media/icon_checkbox_empty.8dbda0ca.svg";